// Small bar chart used by the owner dashboard trend cards and the library growth strip.
export const Bars = ({ data, labels, color, money }) => {
  const W = 320, H = 56, n = data.length, max = Math.max(1, ...data), gap = 4, bw = (W - gap * (n - 1)) / n;
  const fmt = (v) => (money ? `$${Math.round(v).toLocaleString()}` : Math.round(v).toLocaleString());
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="h-10 w-full" preserveAspectRatio="none" data-testid="trend-bars">
      <defs><linearGradient id={`g-${color.slice(1)}`} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={color} stopOpacity="0.95" /><stop offset="100%" stopColor={color} stopOpacity="0.35" /></linearGradient></defs>
      <line x1="0" y1={H - 0.5} x2={W} y2={H - 0.5} stroke="rgba(255,255,255,0.08)" />
      {data.map((v, i) => { const h = Math.max(2, (v / max) * (H - 8)), x = i * (bw + gap), last = i === n - 1; return (
        <g key={i} className="trend-bar">
          <title>{labels[i]}: {fmt(v)}</title>
          <rect x={x} y={H - h} width={bw} height={h} rx={2} fill={last ? color : `url(#g-${color.slice(1)})`} opacity={last ? 1 : 0.75} />
        </g>
      ); })}
    </svg>
  );
};

// Compact 12-week trend tile — lives in the header, right of the tabs / action buttons.
